module.exports = __webpack_public_path__ + "img/bg-login-mobile.d86ddd61.jpg";